<div>
  <app-error-margins-filter *ngIf="errors"
    [errors]="errors.content"
    (search)="searchErrors($event)">
  </app-error-margins-filter>
  <mat-divider></mat-divider>
  <app-error-margins-table *ngIf="errors"
    [errors]="errors.content"
    [page]="errors.number"
    [pageSize]="errors.size"
    [totalElements]="errors.totalElements"
    (loadErrors)="loadErrors($event)">
  </app-error-margins-table>
</div>
